const projectApi = '/app/track/getProjectShowList'
const type = [
    {
        label: '全部',
        filter: {
        },
    },
    {
        label: '今日开标',
        filter: {
            fenLei: 2,
        },
    },
]
const mixin = {
    data() {
        return {
            timerList1: [],
            timerList2: [],
        }
    },
    methods: {
        clearTimer(timerList) {
            for (let index = 0; index < timerList.length; index++) {
                clearInterval(timerList[index].timer)
            }
        },
        setTimer(timerList) {
            for (let index = 0; index < timerList.length; index++) {
                timerList[index].timer = setInterval(() => {
                    timerList[index].value.restTime = this.$util.getMinusTime(timerList[index].value.kbTime)
                }, 1000)
            }
        },
        typeChange() {
            for (let index = 0; index < 2; index++) {
                this.clearTimer(this[`timerList${index + 1}`])
            }
            this.setTimer(this[`timerList${this.active + 1}`])
        },
        mappingData(arr, pageIndex) {
            return arr.map((t) => {
                t.kbTime = parseInt(t.kbTime, 0) + parseInt((new Date()).valueOf(), 0) // 还原开标时间
                this.$set(t, 'restTime', t.kbTime - (new Date()).valueOf() > 0 ? this.$util.getMinusTime(t.kbTime) : '已截标')
                this.$set(t, 'kbStatus', t.kbTime - (new Date()).valueOf() > 0 > 0 ? 1 : 3)
                // 刷新时(请求第一页,清空该页所有定时器)
                if (pageIndex === 1) {
                    this.clearTimer(this[`timerList${this.active + 1}`])
                }
                this.$nextTick(() => {
                    // 防止产生重复定时器
                    const existTimer = this[`timerList${this.active + 1}`].find((x) => x.value.id === t.id)
                    if (existTimer) {
                        clearInterval(existTimer.timer)
                        this[`timerList${this.active + 1}`].splice(this[`timerList${this.active + 1}`].indexOf(existTimer), 1)
                    }
                    if (t.kbTime - (new Date()).valueOf() > 0) {
                        const timer = setInterval(() => {
                            t.restTime = this.$util.getMinusTime(t.kbTime)
                        }, 1000)
                        this[`timerList${this.active + 1}`].push({
                            timer: timer,
                            value: t,
                        })
                    }
                })
                return t
            })
        },
    },
    activated() {
        this.setTimer(this[`timerList${this.active + 1}`])
    },
    deactivated() {
        for (let index = 0; index < 2; index++) {
            this.clearTimer(this[`timerList${index + 1}`])
        }
    },
}

module.exports = {
    projectApi,
    mixin,
    type,
}
